module.exports = __webpack_public_path__ + "img/teflon_covered_nipples.20efbe87.webp";